import AuthService from "../auth/auth_service.js";

export default class ServiceService extends AuthService {
  constructor(){
    super("service")
  }
}
